// ScheduleCascadeService.js

import { functions, httpsCallable } from 'firebaseConfig';

/**
 * Persist a schedule edit with server-side FS/SS cascade planning.
 *
 * @param {object} params
 * @returns {Promise<object>}
 */
export async function updateTaskScheduleWithCascade({
  baseKey,
  changedTaskKey,
  typeKey,
  fieldName = 'schedule',
  nextSchedule,
  mode = 'push',
  candidateKeys = [],
} = {}) {
  const fn = httpsCallable(functions, 'updateTaskScheduleWithCascade');
  const start = nextSchedule?.start || nextSchedule?.startDate;
  const end = nextSchedule?.end || nextSchedule?.endDate;
  const result = await fn({
    baseKey,
    changedTaskKey,
    typeKey,
    fieldName,
    mode,
    candidateKeys,
    nextSchedule: {
      startMs: start instanceof Date ? start.getTime() : Number(start),
      endMs: end instanceof Date ? end.getTime() : Number(end),
    },
  });
  return result?.data || result;
}
